module.exports = __webpack_public_path__ + "img/flight.24497b30.png";